import { drmSubmitTableData } from "../../service/drmSubmitTableData";
import {
  setSubmitDrmTableDataSuccess,
  setSubmitDrmTableDataFailure,
} from "../reducers/drmtSubmitTableDataSlice";

import { put, takeLatest, call } from "redux-saga/effects";

export function* workerSubmitDrmTableDat(action) {
  const { payload } = action;

  try {
    const response = yield call(drmSubmitTableData, [
      payload.userCode,
      payload.submitDetails,
      payload.tableName,
      payload.controller,
    ]);

    yield put(setSubmitDrmTableDataSuccess(response.data.message));
  } catch (error) {
    yield put(setSubmitDrmTableDataFailure(error.toString()));
  }
}

function* drmSubmitTableDataSaga() {
  yield takeLatest(
    "submitDrmtTableData/setSubmitDrmTableData",
    workerSubmitDrmTableDat
  );
}

export default drmSubmitTableDataSaga;
